import { render } from "./ComponentSource.vue?vue&type=template&id=8b2efda2"
import script from "./ComponentSource.vue?vue&type=script&lang=js"
export * from "./ComponentSource.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__